// @ts-check

/** @file One-shot readiness boundary for initial current-user loading. */

let loaded = false
/** @type {(() => void) | null} */
let resolveLoaded = null
const loadedPromise = new Promise((resolve) => { resolveLoaded = () => resolve() })

/**
 * Publishes that the first current-user load has reached a terminal UI state.
 * @returns {void} Nothing.
 */
export function markInitialCurrentUserLoadComplete() {
  if (loaded) return
  loaded = true
  resolveLoaded?.()
  resolveLoaded = null
}

/**
 * Waits until startup can no longer mutate session state behind fixture work.
 * @returns {Promise<void>} Completion after the initial current-user load.
 */
export async function waitForInitialCurrentUserLoad() {
  if (loaded) return
  await loadedPromise
}
